<template>
  <div class="content-box">
    <Else></Else>
    <div class="brand-list-title" style="border-bottom:1px solid #D8D8D8;">
      <div style="display:inline-block;border-bottom:1px solid #323232;font-size:18px;">{{ id | idFilter }}</div>
    </div>
    <div>
      <span style="margin-right:20px;">企业名称</span>
      <el-input v-model="companyName" size="mini" style="width:240px;margin-right:30px;" clearable placeholder="请输入企业名称"></el-input>
      <el-button class="main-btn" size="mini" @click="getData">查询</el-button>
    </div>
    <el-row style="height: 42px;background: #F8F8F8;border: 1px solid #EEEEEE; display:flex;align-items: center;padding-left:20px;margin:30px 0 30px 0;">
      <span>
        企业总数{{ tableData.length || 0}}个
      </span>
        <span style="margin-left:20px;">
        商标总数{{ brandAllNumber || 0 }}个
      </span>
    </el-row>
    <div>
      <el-table :data="tableData" :header-cell-style="{background:'#F8F8F8',color:'#333'}">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="key" label="企业名称"></el-table-column>
        <el-table-column prop="doc_count" label="商标数量"></el-table-column>
        <el-table-column label="管理">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDetail(scope.row,scope.$index)">查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getAuthInfos, knowledgeAllZhangYe} from "../../api/api";
import Else from '../ui/else.vue';

export default {
  name: "brandList",
  data() {
    return {
      tableData: [],
      brandAllNumber:'',
      companyName:''
    }
  },
  filters:{
    idFilter(e){
      let props = {
        1:'商标总数',
        2:'已注册商标',
        3:'申请中商标',
        4:'续展期商标',
        5:'宽展期商标',
        6:'失效商标',
      }
      return props[e] || ''
    }
  },
  components: {
    Else
  },
  computed:{
    id(){
      console.log(this.$route);
      return this.$route.params.id
    }
  },
  mounted(){
    this.getData();
  },
  methods: {
    handleDetail(row) {
      let id = this.$route.params.id;
      this.$router.push(`/intellectualProperty/companyBrandList/${id}?companyName=${row.key}`)
    },
    async getAuthInfos() { //获取认证公司名列表
      this.loading = true;
      let userBusinessCode = this.$route.query.company;
      let res = await getAuthInfos({
          userBusinessCode
      })
      if (res.data.code === 200) {
        let comList = res.data.data.map(i => i.businessName)
        if(comList.indexOf(userBusinessCode) == -1){
          comList.push(userBusinessCode)
        }
        return comList || []
      }
      this.loading = false;
    },
    async getData(){
      let type = this.$route.params.id;
      let comList = await this.getAuthInfos();
      if(comList && Array.isArray(comList) && comList.length > 0){
        comList = comList.filter(i=>i.indexOf(this.companyName) !== -1)
      }
      let res = await knowledgeAllZhangYe({
        type,
        comList,
        index:1,
        size:20
      })
      if(res.data.code === 200){
        if(this.companyName && Array.isArray(res.data.data.count_tmapplicant) && res.data.data.count_tmapplicant.length > 0){
          this.tableData = res.data.data.count_tmapplicant.filter(i=>{
            return i.key.indexOf(this.companyName) !== -1
          }) || []
        }else{
          this.tableData = res.data.data.count_tmapplicant || []
        }
        this.brandAllNumber = res.data.data.total;
        //子向父发送数据
      this.$nextTick(()=>{
        var height =  document.documentElement.scrollHeight;
        console.log(height)
          window.parent.postMessage(
          {
            data: height,
          },
          "*"
        );
      })
      }
    }
  }
}
</script>

<style scoped>
.brand-list-title{
  font-weight: 500;
  color: #353535;
  line-height: 25px;
  margin-bottom: 30px;

}
.content-box {
  background: #FFFFFF;
  margin-top: 20px;
  padding: 40px;
}
.main-btn {
  background: #EB5E00;
  border-radius: 4px;
  color:#fff;
  border:none;
}
</style>
